import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { MenuIndicatorKind } from './MenuIndicator';
export const Wrapper = styled(Box)(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(1)
}));
export const Indicator = styled(Box)(({
  theme,
  kind
}) => ({
  width: 20,
  height: 20,
  flexShrink: 0,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.common.white,
  background: kind === MenuIndicatorKind.Error ? theme.palette.error[800] : theme.palette.secondary[300]
}));